import clipboard from 'clipboard';

const clipboard_ = clipboard;

export default {
	data() {
		return {
			clipboard: clipboard_
		}
	}
}